export default __webpack_public_path__ + "static/media/ys2.bd891bf4.jpg";